import {RestService} from "@/services/rest/RestService";
import {PopupEndpointsApi} from "@/api/pharma-cms-popup";
import {
    CreatePopupRestDto,
    FullPopupRestDto,
    PopupOverviewResultsRestDto,
    PopupRestDto,
    StatusValueRestDto
} from "@/api/pharma-cms-popup/models";
import {CacheService} from "@/services/cache/CacheService";
import {CacheKeyEnum} from "@/services/cache/CacheKeyEnum";

export class PopupRestService extends RestService {

    private apiService: PopupEndpointsApi;


    protected constructor() {
        super();
        this.apiService = new PopupEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    public async addPopup(createPopup: CreatePopupRestDto): Promise<void> {
        await this.apiService.createPopup(createPopup);
        CacheService.getInstance().invalidate(CacheKeyEnum.PAGED_POPUP_OVERVIEW);
    }

    public async deletePopup(id: string): Promise<void> {
        await this.apiService.deletePopup(id);
        CacheService.getInstance().invalidate(CacheKeyEnum.PAGED_POPUP_OVERVIEW);
    }

    public async getPopup(id: string): Promise<FullPopupRestDto> {
        const cacheKey = CacheKeyEnum.POPUP + '_' + id;
        let result: FullPopupRestDto | undefined = CacheService.getInstance().get(cacheKey);
        if (result) {
            return result;
        }

        const response = await this.apiService.getPopupById(id);
        result = response.data;

        CacheService.getInstance().set(cacheKey, result);
        return result;
    }

    public async updatePopup(id: string, popup: PopupRestDto): Promise<void> {
        await this.apiService.updatePopup(popup, id);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP + '_' + id);
        CacheService.getInstance().invalidate(CacheKeyEnum.PAGED_POPUP_OVERVIEW);
    }

    public async updatePopupStatus(status: StatusValueRestDto, popupId: string): Promise<void> {
        await this.apiService.updatePopupStatus(status, popupId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP + '_' + popupId);
        CacheService.getInstance().invalidate(CacheKeyEnum.PAGED_POPUP_OVERVIEW);
    }

    public async getPopups(): Promise<PopupOverviewResultsRestDto> {
        let result: PopupOverviewResultsRestDto | undefined =
            CacheService.getInstance().get(CacheKeyEnum.PAGED_POPUP_OVERVIEW);
        if (result) {
            return result;
        }

        const response = await this.apiService.getPopupOverview();
        result = response.data;
        CacheService.getInstance().set(CacheKeyEnum.PAGED_POPUP_OVERVIEW, result);

        return result;
    }

    public popupsChanged(): void {
        CacheService.getInstance().invalidate(CacheKeyEnum.PAGED_POPUP_OVERVIEW);
    }
}
